import React from "react";
import img1 from "assets/landing/block-who-we-help-1.webp";
import img2 from "assets/landing/block-who-we-help-2.webp";
import { useTranslation } from "locales";
import useModalLinkPrinter from "hooks/useModalLinkPrinter";
import BaseButton from "components/BaseButton";
import BaseIcon from "components/BaseIcon";
import "./style.scss";

export default function BlockWhoWeHelp() {
  const { t } = useTranslation();
  const { getLocation } = useModalLinkPrinter();

  return (
    <div className="block-who-we-help d-flex __align-center __column">
      <h2 className="block-who-we-help__title h1 mb-4 text-center">{t("Who we help")}</h2>
      <div className="block-who-we-help__description subtitle-1 text-neutral-darken-1 text-center mb-10">
        {t(
          "We partner with both students and universities to deliver specialist employability results in financial services."
        )}
      </div>

      <div className="block-who-we-help__wrapper d-flex gap-6">
        <div className="block-who-we-help__item box-shadow">
          <div className="block-who-we-help__item-img" style={{ backgroundImage: `url(${img1})` }}></div>
          <div className="pa-6 d-flex __column">
            <div className="block-who-we-help__item-title headline-2 fw-bold mb-1">{t("Students")}</div>
            <div className="block-who-we-help__item-subtitle headline-4 mb-3">{t("Clarity. Confidence. Offers.")}</div>
            <div className="block-who-we-help__item-description mb-5 text-neutral-darken-1">
              {t(
                "From CV’s to final interviews, our insider coaches help you master every stage of the process - so you perform with confidence and clarity when it counts."
              )}
            </div>
            <BaseButton
              className="block-who-we-help__btn body-1 fw-bold pl-4 pr-3 mt-auto"
              to={"/coaches"}
              large
              gradient
            >
              {t("Find a Coach")}
              <BaseIcon className="f-shrink-0 ml-2">chevron-right</BaseIcon>
            </BaseButton>
          </div>
        </div>

        <div className="block-who-we-help__item box-shadow">
          <div className="block-who-we-help__item-img" style={{ backgroundImage: `url(${img2})` }}></div>
          <div className="pa-6 d-flex __column">
            <div className="block-who-we-help__item-title caption-1 fw-bold mb-1">{t("Universities")}</div>
            <div className="block-who-we-help__item-subtitle body-1 fw-semibold mb-3">
              {t("Boost employability. Strengthen rankings. Satisfy students.")}
            </div>
            <div className="body-2 mb-5 text-neutral-darken-1">
              {t(
                "We complement existing career services with scalable, outcome-led coaching that lifts graduate outcomes, student satisfaction, and employability rankings."
              )}
            </div>
            <BaseButton
              className="block-who-we-help__btn body-1 fw-bold pl-4 pr-3 mt-auto"
              to={getLocation("/contact-us")}
              large
              dark
            >
              {t("Discuss a Pilot")}
              <BaseIcon className="f-shrink-0 ml-2">chevron-right</BaseIcon>
            </BaseButton>
          </div>
        </div>
      </div>
    </div>
  );
}
